import { createTheme } from "@mantine/core";

/** Dense ops-tool theme: tighter default sizes, monospace-friendly. */
export const theme = createTheme({
  primaryColor: "indigo",
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, monospace",
  defaultRadius: "md",
  components: {
    Table: {
      defaultProps: {
        fz: "sm",
      },
    },
  },
});
